import { options as defaultOptions, overrideOptions } from './splitPane.defaults';
import LayoutContainer from './layoutContainer';
export default class Overlay extends LayoutContainer {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    //this._defaultShow = true;
  }

  renderElement() {
    const options = _.defaultsDeep(this._controlOptions, defaultOptions);
    _.merge(options,overrideOptions);
    // options.splitter.isLayoutMode = false;
    // options.splitter.isDesignMode = false;
    // options.splitter.designMode = false;

    options.controls[1].type = 'splitter';
    options.controls[1].splitFrom = this.path+'.controls[0]';
    options.controls[1].splitTo = this.path+'.controls[2]';
    options.controls[1].orientation = options.orientation=='vertical'?'horizontal':'vertical';
    options.controls[1].persistent = options.persistent;
    
    // options.controls[0].originalPath = this.path + '.pane1';
    // options.controls[2].originalPath = this.path + '.pane2';

    // options.controls = _.merge(options.controls||[],[
    //   _.cloneDeepWithFunctions(options.controls[0]),
    //   _.cloneDeepWithFunctions(options.controls[1]),
    //   _.cloneDeepWithFunctions(options.controls[2])
    // ]);
    
    const el = super.renderElement();
    
    this.instance.controls[options.controls[1].splitFrom].addClass('no-layout');
    this.instance.controls[this.path+'.controls[1]'].addClass('no-layout');
    this.instance.controls[options.controls[1].splitTo].addClass('no-layout');

    return el;
  }
}
